import { useSelector } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTRSRegistration } from '@/API/TRSRegistration/deleteTRSRegistration';

const useDeleteTRSRegistration = (onSuccess, onError) => {
    const queryClient = useQueryClient();
    const { requiredScope } = useSelector((state) => state.login);

    const mutation = useMutation({
        mutationFn: async (registrationID) => {
            try {
                const response = await deleteTRSRegistration(
                    registrationID,
                    requiredScope,
                );
                return response.data;
            } catch (error) {
                console.error('Failed to delete TRS Registration:', error);
                throw error;
            }
        },
        onSuccess: (data, registrationID) => {
            // Remove the deleted registration from cache
            queryClient.setQueryData(['TRSRegistrations'], (oldData) => {
                if (!oldData) return [];
                return oldData.filter((item) => item.id !== registrationID);
            });

            // Invalidate and refetch related queries
            queryClient.invalidateQueries(['TRSRegistrations']);

            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            console.error('Failed to delete TRS Registration:', error);
            if (onError) {
                onError(error);
            }
        },
    });

    return mutation;
};

export default useDeleteTRSRegistration;
